import { memo, Fragment } from 'react';

import QuestionViewer from '../QuestionViewer';
import FileFieldsEditor, { FileFieldsViewer } from './FileFields';
import { IFileQuestionView, QuestionState } from 'store/survey/surveyTypes';
import { appDispatch } from '../../../../../../store/store';
import IconTypes from '../../../../../Icon/IconTypes';
import { IQuestionViewerProp } from '../GeneralQuestion/GeneralQuestionViewer';

interface IFileQuestionViewerProp extends IQuestionViewerProp {
  question: { data: IFileQuestionView; state: QuestionState };
}

const FileQuestionViewer: React.FC<IFileQuestionViewerProp> = ({
  tags,
  index,
  surveyId,
  question,
  displayDeleted,
  providerSurvey,
  readOnly,
  ...otherProps
}) => {
  const {
    data: { maxSizeInKB, validFormat },
  } = question;
  return (
    <QuestionViewer
      icon={'file' as IconTypes}
      tags={tags}
      index={index}
      surveyId={surveyId}
      question={question}
      dispatch={appDispatch}
      providerSurvey={providerSurvey}
      displayDeleted={displayDeleted}
      readOnly={readOnly}
      child={(editing: boolean) =>
        !editing ? (
          <FileFieldsViewer
            maxSize={maxSizeInKB ? maxSizeInKB : 512}
            validFormats={validFormat || undefined}
          />
        ) : (
          <Fragment>
            <FileFieldsEditor />
          </Fragment>
        )
      }
      {...otherProps}
    />
  );
};

export default memo(
  FileQuestionViewer,
  (prevProps: IFileQuestionViewerProp, nextProps: IFileQuestionViewerProp) => {
    return (
      prevProps.question === nextProps.question &&
      prevProps.index === nextProps.index &&
      prevProps.questionState === nextProps.questionState
    );
  }
);
